import { Editor, Transforms } from 'slate';
import createTextBlock from '@atlas/tool/box/slate/createTextBlock';

export default function removeTopLevelBlocks(editor: Editor, from: number, to?: number, safe = false) {
    if (typeof to === 'undefined' || from === to) {
        Transforms.removeNodes(editor, { at: [from] });
    } else {
        const anchor = Editor.start(editor, [from]);
        const focus = Editor.end(editor, [to]);
        const before = editor.children.length;

        Transforms.removeNodes(editor, {
            at: { anchor, focus },
            match: (_node, path) => path.length === 1,
        });

        const after = editor.children.length;
        const matched = to - from + 1;
        if (matched > before - after) {
            Transforms.removeNodes(editor, { at: [from] });
        }
    }

    if (safe && !editor.children.length) {
        Transforms.insertNodes(editor, createTextBlock());
    }
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('removeTopLevelBlocks', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
